module.exports = __webpack_public_path__ + "img/home_title4.f5e3f891.png";